import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Branches } from "../../store/branches/actions";
export var useBranchesGetAll = function (trigger, name, code) {
    var _a = useState(true), enable = _a[0], setEnable = _a[1];
    var _b = useState(1), page = _b[0], setPage = _b[1];
    var _c = useState(100), limit = _c[0], setLimit = _c[1];
    var dispatch = useDispatch();
    var _d = useSelector(function (state) {
        var _a;
        return ({
            responseBranches: (_a = state.Branches.responseBranches) === null || _a === void 0 ? void 0 : _a.data,
            errorBranches: state.Branches.errorBranches,
            loadingBranches: state.Branches.loadingBranches,
        });
    }), responseBranches = _d.responseBranches, errorBranches = _d.errorBranches, loadingBranches = _d.loadingBranches;
    useEffect(function () {
        if (trigger) {
            dispatch(Branches({
                enable: enable,
                page: page,
                limit: limit,
                name: name,
                code: code,
            }));
        }
    }, [trigger]);
    return {
        responseBranches: responseBranches,
        errorBranches: errorBranches,
        loadingBranches: loadingBranches,
        setEnable: setEnable,
        setPage: setPage,
        setLimit: setLimit,
    };
};
